<!-- Header -->
<app-card-header [title]="title" icono="directions_car"></app-card-header>

<!-- Template reutilizable para preview -->
<ng-template
  #iconPreview
  let-vistaControl="vistaControl"
  let-iconField="iconField"
>
  @if (vistaControl.get(iconField)?.value) {
    <div style="position: relative; width: 50px; height: 50px">
      <img
        src="assets/map/vehiculos/centro branco.png"
        style="
          position: absolute;
          top: 0;
          left: 0;
          width: 50px;
          height: 50px;
          filter: brightness(0) saturate(100%) invert(50%) sepia(0%)
            saturate(0%) hue-rotate(0deg) brightness(95%) contrast(90%);
        "
      />
      <img
        src="assets/map/vehiculos/circle branco.png"
        style="position: absolute; top: 0; left: 0; width: 50px; height: 50px"
      />
      <img
        [src]="vistaControl.get(iconField)?.value"
        alt="Ícono"
        style="
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 18px;
          height: 18px;
          object-fit: cover;
        "
        (error)="$event.target.src = ''; $event.target.alt = 'Error'"
      />
    </div>
  } @else {
    <span style="font-size: 0.75em; color: #999; text-align: center">
      Sin preview
    </span>
  }
</ng-template>

@if (form) {
  <form
    id="form"
    [formGroup]="form"
    autocomplete="off"
    (ngSubmit)="onSubmit()"
    style="
      display: flex;
      flex-direction: column;
      height: calc(100% - 64px);
      overflow: hidden;
    "
  >
    <!-- Content -->
    <mat-card-content
      style="margin: 1em; flex: 1; overflow-y: auto; overflow-x: hidden"
    >
      <app-section-title title="Configuración General"></app-section-title>

      <!-- Global -->
      <div style="margin-bottom: 0.8em">
        <app-checkbox
          formControlName="global"
          title="Global"
          hint="Configuración para todos los usuarios del cliente"
          margin="6px 6px"
        ></app-checkbox>
      </div>

      <!-- Scope e ID Referencia -->
      <div
        style="
          display: grid;
          grid-template-columns: 1fr 2fr;
          gap: 0.8em;
          align-items: start;
          margin-bottom: 1em;
        "
      >
        <ng-select
          formControlName="scope"
          placeholder="Alcance"
          [items]="scopes"
          bindValue="value"
          bindLabel="label"
          appendTo="body"
          notFoundText="Sin resultados"
        ></ng-select>

        <!-- ID Referencia según scope -->
        <div style="margin: 0">
          @if (scopeSeleccionado === 'cliente') {
            <app-cliente-selector
              formControlName="idRef"
            ></app-cliente-selector>
          }

          @if (scopeSeleccionado === 'grupo') {
            <ng-select
              [items]="grupos"
              bindLabel="nombre"
              bindValue="_id"
              placeholder="Seleccioná un grupo"
              formControlName="idRef"
              [notFoundText]="'No hay grupos disponibles'"
              [clearable]="true"
              [searchable]="true"
            >
              <ng-template ng-label-tmp let-item="item">
                {{ item.nombre }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{ item.nombre }}
              </ng-template>
            </ng-select>
          }

          @if (scopeSeleccionado === 'activo') {
            <ng-select
              [items]="activos"
              bindLabel="identificacion"
              bindValue="_id"
              placeholder="Seleccioná un activo"
              formControlName="idRef"
              [notFoundText]="'No hay activos disponibles'"
              [clearable]="true"
              [searchable]="true"
            >
              <ng-template ng-label-tmp let-item="item">
                {{ item.identificacion }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{ item.identificacion }}
              </ng-template>
            </ng-select>
          }
        </div>
      </div>

      <mat-divider style="margin: 0.5em 0 0.8em 0"></mat-divider>

      <!-- Markers -->
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 0.6em;
        "
      >
        <app-section-title title="Markers"></app-section-title>
        @if (scopeSeleccionado !== 'activo') {
          <button
            irxBotonIcono="relleno"
            type="button"
            (click)="agregarVista()"
            tooltip="Agregar todas las configuraciones"
          >
            <mat-icon>add</mat-icon>
          </button>
        }
      </div>

      <!-- Vista simplificada para Activo: Solo una opción de tipo y una de función -->
      @if (scopeSeleccionado === 'activo') {
        <div
          style="
            display: grid;
            grid-template-columns: 1fr auto 1fr;
            gap: 1.5em;
            align-items: start;
          "
        >
          <!-- Configuración por Tipo -->
          @if (vistas.length > 0) {
            <div [formGroup]="$any(vistas.at(0))">
              <strong
                style="font-size: 0.95em; margin-bottom: 0.6em; display: block"
              >
                Configuración por Tipo
              </strong>

              <div
                style="
                  display: grid;
                  grid-template-columns: 2fr auto 1fr;
                  gap: 0.4em;
                  margin-top: 0.8em;
                "
              >
                <mat-form-field style="margin: 0">
                  <mat-label>URL Ícono</mat-label>
                  <input matInput formControlName="vehicleTypeIcon" />
                </mat-form-field>
                <button
                  irxBotonIcono="borde"
                  tono="primario"
                  type="button"
                  tooltip="Subir imagen"
                  style="align-self: center"
                  (click)="subirIcono('tipo', 0)"
                >
                  <mat-icon>upload</mat-icon>
                </button>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    min-height: 60px;
                  "
                >
                  <ng-container
                    *ngTemplateOutlet="
                      iconPreview;
                      context: {
                        vistaControl: vistas.at(0),
                        iconField: 'vehicleTypeIcon',
                      }
                    "
                  ></ng-container>
                </div>
              </div>

              <!-- Opciones de color -->
              <div
                style="
                  display: grid;
                  grid-template-columns: repeat(2, 1fr);
                  gap: 0.8em;
                  font-size: 0.85em;
                  margin-top: 0.8em;
                "
              >
                <app-checkbox
                  formControlName="useOriginalIconColor"
                  [title]="'Color Original'"
                  tooltip="No aplica colores personalizados"
                  margin="2px 6px"
                ></app-checkbox>
                <app-checkbox
                  formControlName="groupColorIcon"
                  [title]="'Color Flota (Ícono)'"
                  margin="2px 6px"
                ></app-checkbox>
                <app-checkbox
                  formControlName="groupColorBackground"
                  [title]="'Color Flota (Fondo)'"
                  margin="2px 6px"
                ></app-checkbox>
                <app-checkbox
                  formControlName="movingDegraded"
                  [title]="'Degradado'"
                  tooltip="Amarrillo a rojo según velocidad"
                  margin="2px 6px"
                ></app-checkbox>
              </div>

              <!-- Colores de Estado -->
              <div
                style="
                  display: flex;
                  gap: 1em;
                  align-items: flex-start;
                  justify-content: space-around;
                  margin-top: 0.8em;
                "
              >
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                  "
                >
                  <ngx-colors
                    ngx-colors-trigger
                    formControlName="vehiculeTypeIconColor"
                  ></ngx-colors>
                  <span style="font-size: 0.75em; margin-top: 0.2em">
                    Ícono
                  </span>
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                  "
                >
                  <ngx-colors
                    ngx-colors-trigger
                    formControlName="offColor"
                  ></ngx-colors>
                  <span style="font-size: 0.75em; margin-top: 0.2em">
                    Apagado
                  </span>
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                  "
                >
                  <ngx-colors
                    ngx-colors-trigger
                    formControlName="stopColor"
                  ></ngx-colors>
                  <span style="font-size: 0.75em; margin-top: 0.2em">
                    Detenido
                  </span>
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                  "
                >
                  <ngx-colors
                    ngx-colors-trigger
                    formControlName="movingColor"
                  ></ngx-colors>
                  <span style="font-size: 0.75em; margin-top: 0.2em">
                    Movimiento
                  </span>
                </div>
              </div>
            </div>
          }

          <!-- Divisor vertical -->
          <mat-divider [vertical]="true" style="height: 100%"></mat-divider>

          <!-- Configuración por Función -->
          @if (vistas.length > 1) {
            <div [formGroup]="$any(vistas.at(1))">
              <strong
                style="font-size: 0.95em; margin-bottom: 0.6em; display: block"
              >
                Configuración por Función
              </strong>

              <div
                style="
                  display: grid;
                  grid-template-columns: 2fr auto 1fr;
                  gap: 0.4em;
                  margin-top: 0.8em;
                "
              >
                <mat-form-field style="margin: 0">
                  <mat-label>URL Ícono</mat-label>
                  <input matInput formControlName="vehicleFunctionIcon" />
                </mat-form-field>
                <button
                  irxBotonIcono="borde"
                  tono="primario"
                  type="button"
                  tooltip="Subir imagen"
                  style="align-self: center"
                  (click)="subirIcono('funcion', 1)"
                >
                  <mat-icon>upload</mat-icon>
                </button>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    min-height: 60px;
                  "
                >
                  <ng-container
                    *ngTemplateOutlet="
                      iconPreview;
                      context: {
                        vistaControl: vistas.at(1),
                        iconField: 'vehicleFunctionIcon',
                      }
                    "
                  ></ng-container>
                </div>
              </div>

              <!-- Opciones de color -->
              <div
                style="
                  display: grid;
                  grid-template-columns: repeat(2, 1fr);
                  gap: 0.8em;
                  font-size: 0.85em;
                  margin-top: 0.8em;
                "
              >
                <app-checkbox
                  formControlName="useOriginalIconColor"
                  [title]="'Color Original'"
                  tooltip="No aplica colores personalizados"
                  margin="2px 6px"
                ></app-checkbox>
                <app-checkbox
                  formControlName="groupColorIcon"
                  [title]="'Color Flota (Ícono)'"
                  margin="2px 6px"
                ></app-checkbox>
                <app-checkbox
                  formControlName="groupColorBackground"
                  [title]="'Color Flota (Fondo)'"
                  margin="2px 6px"
                ></app-checkbox>
                <app-checkbox
                  formControlName="movingDegraded"
                  [title]="'Degradado'"
                  tooltip="Verde a rojo según velocidad"
                  margin="2px 6px"
                ></app-checkbox>
              </div>

              <!-- Colores de Estado -->
              <div
                style="
                  display: flex;
                  gap: 1em;
                  align-items: flex-start;
                  justify-content: space-around;
                  margin-top: 0.8em;
                "
              >
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                  "
                >
                  <ngx-colors
                    ngx-colors-trigger
                    formControlName="vehicleFunctionIconColor"
                  ></ngx-colors>
                  <span style="font-size: 0.75em; margin-top: 0.2em">
                    Ícono
                  </span>
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                  "
                >
                  <ngx-colors
                    ngx-colors-trigger
                    formControlName="offColor"
                  ></ngx-colors>
                  <span style="font-size: 0.75em; margin-top: 0.2em">
                    Apagado
                  </span>
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                  "
                >
                  <ngx-colors
                    ngx-colors-trigger
                    formControlName="stopColor"
                  ></ngx-colors>
                  <span style="font-size: 0.75em; margin-top: 0.2em">
                    Detenido
                  </span>
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                  "
                >
                  <ngx-colors
                    ngx-colors-trigger
                    formControlName="movingColor"
                  ></ngx-colors>
                  <span style="font-size: 0.75em; margin-top: 0.2em">
                    Movimiento
                  </span>
                </div>
              </div>
            </div>
          }
        </div>
      }

      <!-- Vista completa para Cliente y Grupo: Dos columnas independientes: Tipos y Funciones -->
      @if (scopeSeleccionado !== 'activo') {
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1em">
          <!-- Columna 1: Tipos de Vehículo -->
          <div style="display: flex; flex-direction: column; gap: 0.6em">
            <strong style="font-size: 0.95em; margin-bottom: 0.2em">
              Tipos de Vehículo
            </strong>
            @for (
              vistaControl of getVistasTipo();
              track $index;
              let i = $index
            ) {
              <mat-expansion-panel
                class="marker-card"
                [expanded]="isCardExpanded(getVistaIndex(vistaControl))"
                (opened)="onPanelTipoOpened(vistaControl)"
                (closed)="onPanelTipoClosed(vistaControl)"
              >
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div
                      style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;
                      "
                    >
                      <strong style="font-size: 0.9em">
                        {{
                          getTipoLabel(vistaControl.get('tipoVehiculo')?.value)
                        }}
                      </strong>
                      @if (vistas.length > 1) {
                        <button
                          irxBotonIcono
                          tono="peligro"
                          type="button"
                          (click)="
                            eliminarVista(getVistaIndex(vistaControl));
                            $event.stopPropagation()
                          "
                          tooltip="Eliminar Vista"
                        >
                          <mat-icon>delete</mat-icon>
                        </button>
                      }
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>

                <div [formGroup]="$any(vistaControl)">
                  <!-- Selector de Tipo -->
                  <div style="margin-bottom: 0.4em">
                    <ng-select
                      formControlName="tipoVehiculo"
                      placeholder="Tipo"
                      [items]="opcionesTipoVehiculo"
                      bindValue="valor"
                      bindLabel="etiqueta"
                      appendTo="body"
                      notFoundText="Sin resultados"
                      style="width: 100%"
                    ></ng-select>
                  </div>

                  <!-- Íconos: Solo Ícono de Tipo -->
                  <div
                    style="
                      display: grid;
                      grid-template-columns: 2fr auto 1fr;
                      gap: 0.4em;
                    "
                  >
                    <mat-form-field style="margin: 0">
                      <mat-label>URL Ícono Tipo</mat-label>
                      <input matInput formControlName="vehicleTypeIcon" />
                    </mat-form-field>
                    <button
                      irxBotonIcono="borde"
                      tono="primario"
                      type="button"
                      tooltip="Subir imagen"
                      style="align-self: center"
                      (click)="subirIcono('tipo', getVistaIndex(vistaControl))"
                    >
                      <mat-icon>upload</mat-icon>
                    </button>
                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        min-height: 60px;
                      "
                    >
                      @if (vistaControl.get('vehicleTypeIcon')?.value) {
                        <div
                          style="position: relative; width: 50px; height: 50px"
                        >
                          <!-- Fondo blanco -->
                          <img
                            src="assets/map/vehiculos/centro branco.png"
                            style="
                              position: absolute;
                              top: 0;
                              left: 0;
                              width: 50px;
                              height: 50px;
                              filter: brightness(0) saturate(100%) invert(50%)
                                sepia(0%) saturate(0%) hue-rotate(0deg)
                                brightness(95%) contrast(90%);
                            "
                          />
                          <!-- Círculo gris (sin orientación) -->
                          <img
                            src="assets/map/vehiculos/circle branco.png"
                            style="
                              position: absolute;
                              top: 0;
                              left: 0;
                              width: 50px;
                              height: 50px;
                            "
                          />
                          <!-- Ícono del vehículo -->
                          <img
                            [src]="vistaControl.get('vehicleTypeIcon')?.value"
                            alt="Ícono"
                            style="
                              position: absolute;
                              top: 50%;
                              left: 50%;
                              transform: translate(-50%, -50%);
                              width: 18px;
                              height: 18px;
                              object-fit: contain;
                            "
                            (error)="
                              $event.target.src = '';
                              $event.target.alt = 'Error'
                            "
                          />
                        </div>
                      } @else {
                        <span
                          style="
                            font-size: 0.75em;
                            color: #999;
                            text-align: center;
                          "
                        >
                          Sin preview
                        </span>
                      }
                    </div>
                  </div>

                  <!-- Opciones de color -->
                  <div
                    style="
                      display: grid;
                      grid-template-columns: repeat(2, 1fr);
                      gap: 0.8em;
                      font-size: 0.85em;
                    "
                  >
                    <app-checkbox
                      formControlName="useOriginalIconColor"
                      [title]="'Color Original'"
                      tooltip="No aplica colores personalizados"
                      margin="2px 6px"
                    ></app-checkbox>
                    <app-checkbox
                      formControlName="groupColorIcon"
                      [title]="'Color Flota (Ícono)'"
                      margin="2px 6px"
                    ></app-checkbox>
                    <app-checkbox
                      formControlName="groupColorBackground"
                      [title]="'Color Flota (Fondo)'"
                      margin="2px 6px"
                    ></app-checkbox>
                    <app-checkbox
                      formControlName="movingDegraded"
                      [title]="'Degradado'"
                      tooltip="Amarrillo a rojo según velocidad"
                      margin="2px 6px"
                    ></app-checkbox>
                  </div>

                  <!-- Colores de Estado (4 columnas compactas) -->
                  <div
                    style="
                      display: flex;
                      gap: 1em;
                      align-items: flex-start;
                      justify-content: space-around;
                      margin-top: 6px;
                    "
                  >
                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                      "
                    >
                      <ngx-colors
                        ngx-colors-trigger
                        formControlName="vehiculeTypeIconColor"
                      ></ngx-colors>
                      <span style="font-size: 0.75em; margin-top: 0.2em">
                        Ícono
                      </span>
                    </div>

                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                      "
                    >
                      <ngx-colors
                        ngx-colors-trigger
                        formControlName="offColor"
                      ></ngx-colors>
                      <span style="font-size: 0.75em; margin-top: 0.2em">
                        Apagado
                      </span>
                    </div>

                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                      "
                    >
                      <ngx-colors
                        ngx-colors-trigger
                        formControlName="stopColor"
                      ></ngx-colors>
                      <span style="font-size: 0.75em; margin-top: 0.2em">
                        Detenido
                      </span>
                    </div>

                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                      "
                    >
                      <ngx-colors
                        ngx-colors-trigger
                        formControlName="movingColor"
                      ></ngx-colors>
                      <span style="font-size: 0.75em; margin-top: 0.2em">
                        Movimiento
                      </span>
                    </div>
                  </div>
                </div>
              </mat-expansion-panel>
            }
          </div>

          <!-- Columna 2: Funciones de Vehículo -->
          <div style="display: flex; flex-direction: column; gap: 0.6em">
            <strong style="font-size: 0.95em; margin-bottom: 0.2em">
              Funciones de Vehículo
            </strong>
            @for (
              vistaControl of getVistasFuncion();
              track $index;
              let i = $index
            ) {
              <mat-expansion-panel
                class="marker-card"
                [expanded]="isCardExpanded(getVistaIndex(vistaControl))"
                (opened)="onPanelFuncionOpened(vistaControl)"
                (closed)="onPanelFuncionClosed(vistaControl)"
              >
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div
                      style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;
                      "
                    >
                      <strong style="font-size: 0.9em">
                        {{
                          getFuncionLabel(
                            vistaControl.get('funcionVehiculo')?.value
                          )
                        }}
                      </strong>
                      @if (vistas.length > 1) {
                        <button
                          irxBotonIcono
                          tono="peligro"
                          type="button"
                          (click)="
                            eliminarVista(getVistaIndex(vistaControl));
                            $event.stopPropagation()
                          "
                          tooltip="Eliminar Vista"
                        >
                          <mat-icon>delete</mat-icon>
                        </button>
                      }
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>

                <div [formGroup]="$any(vistaControl)">
                  <!-- Selector de Función -->
                  <div style="margin-bottom: 0.4em">
                    <ng-select
                      formControlName="funcionVehiculo"
                      placeholder="Función"
                      [items]="opcionesFuncionVehiculo"
                      bindValue="valor"
                      bindLabel="etiqueta"
                      appendTo="body"
                      notFoundText="Sin resultados"
                      style="width: 100%"
                    ></ng-select>
                  </div>

                  <!-- Íconos: Solo Ícono de Función -->
                  <div
                    style="
                      display: grid;
                      grid-template-columns: 2fr auto 1fr;
                      gap: 0.4em;
                    "
                  >
                    <mat-form-field style="margin: 0">
                      <mat-label>URL Ícono Función</mat-label>
                      <input matInput formControlName="vehicleFunctionIcon" />
                    </mat-form-field>
                    <button
                      irxBotonIcono="borde"
                      tono="primario"
                      type="button"
                      tooltip="Subir imagen"
                      style="align-self: center"
                      (click)="
                        subirIcono('funcion', getVistaIndex(vistaControl))
                      "
                    >
                      <mat-icon>upload</mat-icon>
                    </button>
                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        min-height: 60px;
                      "
                    >
                      @if (vistaControl.get('vehicleFunctionIcon')?.value) {
                        <div
                          style="position: relative; width: 50px; height: 50px"
                        >
                          <!-- Fondo blanco -->
                          <img
                            src="assets/map/vehiculos/centro branco.png"
                            style="
                              position: absolute;
                              top: 0;
                              left: 0;
                              width: 50px;
                              height: 50px;
                              filter: brightness(0) saturate(100%) invert(50%)
                                sepia(0%) saturate(0%) hue-rotate(0deg)
                                brightness(95%) contrast(90%);
                            "
                          />
                          <!-- Círculo gris (sin orientación) -->
                          <img
                            src="assets/map/vehiculos/circle branco.png"
                            style="
                              position: absolute;
                              top: 0;
                              left: 0;
                              width: 50px;
                              height: 50px;
                            "
                          />
                          <!-- Ícono del vehículo -->
                          <img
                            [src]="
                              vistaControl.get('vehicleFunctionIcon')?.value
                            "
                            alt="Ícono"
                            style="
                              position: absolute;
                              top: 50%;
                              left: 50%;
                              transform: translate(-50%, -50%);
                              width: 18px;
                              height: 18px;
                              object-fit: contain;
                            "
                            (error)="
                              $event.target.src = '';
                              $event.target.alt = 'Error'
                            "
                          />
                        </div>
                      } @else {
                        <span
                          style="
                            font-size: 0.75em;
                            color: #999;
                            text-align: center;
                          "
                        >
                          Sin preview
                        </span>
                      }
                    </div>
                  </div>

                  <!-- Opciones de color -->
                  <div
                    style="
                      display: grid;
                      grid-template-columns: repeat(2, 1fr);
                      gap: 0.8em;
                      font-size: 0.85em;
                    "
                  >
                    <app-checkbox
                      formControlName="useOriginalIconColor"
                      [title]="'Color Original'"
                      tooltip="No aplica colores personalizados"
                      tooltipPosition="below"
                      margin="2px 6px"
                    ></app-checkbox>
                    <app-checkbox
                      formControlName="groupColorIcon"
                      [title]="'Color Flota (Ícono)'"
                      margin="2px 6px"
                    ></app-checkbox>
                    <app-checkbox
                      formControlName="groupColorBackground"
                      [title]="'Color Flota (Fondo)'"
                      margin="2px 6px"
                    ></app-checkbox>
                    <app-checkbox
                      formControlName="movingDegraded"
                      [title]="'Degradado'"
                      tooltip="Verde a rojo según velocidad"
                      margin="2px 6px"
                    ></app-checkbox>
                  </div>

                  <!-- Colores de Estado (4 columnas compactas) -->
                  <div
                    style="
                      display: flex;
                      gap: 1em;
                      align-items: flex-start;
                      justify-content: space-around;
                    "
                  >
                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                      "
                    >
                      <ngx-colors
                        ngx-colors-trigger
                        formControlName="vehicleFunctionIconColor"
                      ></ngx-colors>
                      <span style="font-size: 0.75em; margin-top: 0.2em">
                        Ícono
                      </span>
                    </div>

                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                      "
                    >
                      <ngx-colors
                        ngx-colors-trigger
                        formControlName="offColor"
                      ></ngx-colors>
                      <span style="font-size: 0.75em; margin-top: 0.2em">
                        Apagado
                      </span>
                    </div>

                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                      "
                    >
                      <ngx-colors
                        ngx-colors-trigger
                        formControlName="stopColor"
                      ></ngx-colors>
                      <span style="font-size: 0.75em; margin-top: 0.2em">
                        Detenido
                      </span>
                    </div>

                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                      "
                    >
                      <ngx-colors
                        ngx-colors-trigger
                        formControlName="movingColor"
                      ></ngx-colors>
                      <span style="font-size: 0.75em; margin-top: 0.2em">
                        Movimiento
                      </span>
                    </div>
                  </div>
                </div>
              </mat-expansion-panel>
            }
          </div>
        </div>
      }
    </mat-card-content>
    <div style="position: sticky; bottom: 0; background: inherit; z-index: 10">
      <mat-divider></mat-divider>
      <!-- Botones -->
      <mat-card-actions class="actions-create">
        <app-button
          matType="mat-fab extended"
          color="neutral"
          (click)="dialogRef.close()"
          text="Cancelar"
          icon="close"
        ></app-button>
        <app-button
          matType="mat-fab extended"
          [disabled]="!this.form.valid || loading"
          color="primary"
          text="Guardar"
          icon="save"
          type="submit"
        ></app-button>
      </mat-card-actions>
    </div>
  </form>
}

<mat-progress-bar
  color="primary"
  [mode]="loading ? 'indeterminate' : 'determinate'"
></mat-progress-bar>
